import { RemoteValidateSmartcard } from "../../../../data/usecases/smartcard/remote-validate-smartcard";
import { ValidateSmartcard } from "../../../../domain/usecases/validate-smartcard";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteValidateSmartcard = (): ValidateSmartcard =>
  new RemoteValidateSmartcard(
    makeApiUrl("/smartcards/validate-smartcard"),
    makeAxiosHttpClient()
  );
